export default "__VITE_ASSET__xKblOm1P__"